module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@bottlebooks/gatsby-theme-event/gatsby-browser.js'),
      options: {"plugins":[],"rootPath":"/de","homePath":"/de/sektproduzenten","exhibitorBase":"sektproduzenten","producerBase":"produzenten","productBase":"sekte","eventId":"5b61e18e737c360fc617465c","locale":"de","showCityFilter":true,"showRegionFilter":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-44225398-6","head":false,"anonymize":true,"respectDNT":true,"exclude":["/preview/**"]},
    }]
